import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error but don't crash the app
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#090A0F] p-4">
          <div className="glass-card p-8 max-w-md w-full text-center">
            <h1 className="text-2xl font-bold text-white mb-4">
              Copa <span className="text-[#FF5A00]">Coruja</span>
            </h1>
            <p className="text-[#A1A1AA] mb-6">
              Ocorreu um erro inesperado. Por favor, recarregue a página.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="btn-primary px-6 py-3 rounded-lg font-medium"
            >
              Recarregar Página
            </button>
            <p className="text-xs text-[#A1A1AA] mt-4">
              Dica: Se o erro persistir, tente desativar extensões do navegador como tradutores automáticos.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
